require('./login.css');
//require('./login.vue');
//alert('Hello World!');

// Swal.fire(
//     'Good job!',
//     'You clicked the button!',
//     'success'
//     );
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
if (urlParams.has('error')){
    // 1
    // "Error logging on, please check username and password"';
    // 2
    // "Session timed out, please log in again"
    // 3
    // "Please login to use this site"
    errorCode = urlParams.get('error');
    var errName = $("#errorMessage"); //Element selector
    switch(errorCode) {
        case 1:
            // Swal.fire(
            //     'Error logging on, please check username and password'
            //     );        

            errName.html("Error logging on, please check username and password"); // Put the message content inside div
            errName.addClass('error-msg');
            break;
        case 2:
            // Swal.fire(
            //     'Session timed out, please log in again'
            //     );            
            errName.html("Session timed out, please log in again"); // Put the message content inside div
            errName.addClass('error-msg');
            break;
        case 3:
            // Swal.fire(
            //     'Please login to use this site'
            //     );            
            errName.html("Please login to use this site"); // Put the message content inside div
            errName.addClass('error-msg');
            break;
        default:
            errName.html("Please login to use this site"); // Put the message content inside div
            errName.addClass('error-msg');
            break;
    }

}


function openNHS() {
	//var packagename = 'com.audienceview.AVEnterprise';
    var packagename = 'uk.gov.dhsc.healthrecord';

	try {
		//Android.openApplication(packagename);
		Android.openApplicationOrInstall(packagename);
	} catch(err) {
        $.notify({
            icon: 'pe-7s-signal',
            message: "NHS COVID Pass Verifier app only available on Android devices with Pontins Kiosk",
        },{
            type: 'danger',
            timer: 4000
        });
	}
}

function openTS() {
	//var packagename = 'com.audienceview.AVEnterprise';
    var packagename = 'uk.co.ticketsource.android.ticketsourceexpress';

	try {
		//Android.openApplication(packagename);
		Android.openApplicationOrInstall(packagename);
	} catch(err) {
        $.notify({
            icon: 'pe-7s-signal',
            message: "AV Enterprise app only available on Android devices with Pontins Kiosk",
        },{
            type: 'danger',
            timer: 4000
        });
	}
}

function openWIFISettings() {
    try {
        Android.openWIFISettings(false);
    } catch(err) {

            $.notify({
                icon: 'pe-7s-signal',
                message: "WiFi settings only available on Android devices with Pontins Kiosk",
            },{
                type: 'danger',
                timer: 4000
            });        
        
    }
}

//GET UNIQUE IDENTIFIER
function getUniqueIdentifier() {
	var kioskID = "";
	try {
		kioskID = Android.getUniqueIdentifier();
	} catch (err) {
		kioskID = "";
	}
	//console.log(kioskID);
	return kioskID;
}


$( document ).ready(function() {
    // DOM is loaded and ready for manipulation here
	//var kioskID = "";
	try {
		const kioskID = getUniqueIdentifier();
		//console.log({ device_id: kioskID });
		if (kioskID.length > 0) {
    		$.ajax({
    		    url: "/api/getKioskName",
    		    type: "POST", 
    		    data: { device_id: kioskID },
    		    dataType: "json",
    		    timeout: 5000,
    		    error: function(xhr, textStatus, error){
    		        console.log({ device_id: kioskID });
    		    }, 
    		    success: function(response, textStatus, jqXHR) {
    		        console.log(response);
    		        strMessage = response.message;
    		        if (response.error == true) {
    				 	//                
    		        } else {
    		            //strIcon = 'pe-7s-tools';
    		            //lTime = 4000;
    		            //sType = 'info';
    		            arData = response;
    		            //console.log(arData);
    		            divDevice = document.getElementById('deviceinfo');
    		            //showInfo(strMessage, sType, strIcon, lTime);
    		            divDevice.innerHTML = '<br><p style="color: white; text-align: center; font-size: 130%;"><strong>' + arData.sDeviceName + '</strong></p>';
                        document.getElementById("kioskID").value = kioskID;
    		        }
    		    },
    		});
		} 
	} catch (err) {
		kioskID = "";
	}
	
});


window.openNHS = openNHS;
window.openTS = openTS;
window.openWIFISettings = openWIFISettings;
window.getUniqueIdentifier = getUniqueIdentifier;
